"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = detectTouchPoint;
/**
 * bb is the bounding box
 * ix,iy are the top-left coordinates
 * ax,ay are the bottom-right coordinates
 * p is the point and x,y its coordinates
 */

function detectTouchPoint(region, e) {
  var bb = region.getBoundingClientRect();
  var pX = e.touches[0].clientX;
  var pY = e.touches[0].clientY;
  var ix = bb.x;
  var iy = bb.y;
  var ax = bb.right;
  var ay = bb.bottom;
  var result = false;
  if (ix <= pX && pX <= ax && iy <= pY && pY <= ay) {
    // Point is in bounding box
    result = true;
  }
  return result;
}